document.addEventListener("DOMContentLoaded", function () {
  const glow = document.createElement("div");
  glow.className = "syn-mouse-glow";
  document.body.appendChild(glow);

  document.addEventListener("mousemove", function (e) {
    glow.style.left = e.clientX + "px";
    glow.style.top = e.clientY + "px";
  });

  const revealItems = document.querySelectorAll(
    "section, .syn-card, .syn-step, .syn-price-card, .syn-partner-card, .builder-card, .testimonial-card"
  );

  revealItems.forEach((item) => {
    item.classList.add("syn-reveal");
  });

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("syn-visible");
        }
      });
    },
    { threshold: 0.12 }
  );

  revealItems.forEach((item) => observer.observe(item));
});